import FlightOffer from "shared/types/flightOffer";

const filterFlightWithInvalidCombinations = (): ((
  flightOffer: FlightOffer
) => boolean) => (flightOffer: FlightOffer) => {
  const allKeys = Object.values(flightOffer.CurrentCombinations)
    .flat()
    .flat()
    .map((a: { Key: string }) => a.Key);

  const flightStreams = flightOffer.FlightItinerary.FlightStream;

  const isValid = flightStreams.every((leg) =>
    leg.some((stream) => allKeys.includes(stream.Key))
  );

  if (!isValid) {
    // eslint-disable-next-line no-console
    console.warn(
      `Flight offer with price ${flightOffer?.PricingDetails?.PricingDetail?.[0]?.FlightPricing?.FlightPrice?.FullPrice} has invalid combinations.`
    );
  }

  return isValid;
};

export default filterFlightWithInvalidCombinations;
